export default {
      id: "icon-ucretsiz-servis-usage",
      viewBox: "0 0 507.4 507.4",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-ucretsiz-servis",
      toString: function () {
        return this.url;
      }
    }